import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as audioVideoActions from 'store/audioVideo/audioVideoActions';
import * as chimeActions from 'store/chime/chimeActions';
import { attendee } from 'utils/apiCalls';

AudioVideoWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};
export default function AudioVideoWrapper({ children }) {
  const dispatch = useDispatch();
  const { hasJoined, audioVideo, meetingId } = useSelector(({ chime }) => ({
    hasJoined: chime.hasJoined,
    audioVideo: chime.audioVideo,
    meetingId: chime.meetingId,
  }));

  useEffect(() => {
    if (hasJoined && meetingId) {
      audioVideo.addObserver({
        videoTileDidUpdate: (tileState) => {
          if (tileState && tileState.boundAttendeeId && tileState.tileId) {
            dispatch(audioVideoActions.audioVideoTileDidUpdateAction({ tileState }));
          }
        },
        videoTileWasRemoved: (tileId) => {
          dispatch(audioVideoActions.audioVideoTileWasRemovedAction({ tileId }));
        },
        /*videoSendHealthDidChange: (bitrateKbps, packetsPerSecond) => {
          console.log(
            '%cvideoSendHealthDidChange: %d %d',
            'background:lime;',
            bitrateKbps,
            packetsPerSecond
          );
        },
        videoSendBandwidthDidChange: (newBandwidthKbps, oldBandwidthKbps, nackCountPerSecond) => {
          console.log(
            '%cvideoSendBandwidthDidChange: %d %d %d',
            'background:lime;',
            newBandwidthKbps,
            oldBandwidthKbps,
            nackCountPerSecond
          );
        },
        connectionDidSuggestStopVideo: () => {
          console.log('%cconnectionDidSuggestStopVideo', 'background:lime;');
        },
        connectionDidBecomeGood: () => {
          console.log('%cconnectionDidBecomeGood', 'background:lime;');
        },
        connectionDidBecomePoor: () => {
          console.log('%cconnectionDidBecomePoor', 'background:lime;');
        },
        estimatedDownlinkBandwidthLessThanRequired: (estimatedBandwidth, requiredBandwidth) => {
          console.log(
            '%cestimatedDownlinkBandwidthLessThanRequired: %d %d',
            'background:lime;',
            estimatedBandwidth,
            requiredBandwidth
          );
        },*/
      });

      audioVideo.realtimeSubscribeToAttendeeIdPresence(
        //eslint-disable-next-line
        async (presentAttendeeId, present, externalUserId) => {
          if (!present) {
            audioVideo.realtimeUnsubscribeFromVolumeIndicator(presentAttendeeId);
            dispatch(chimeActions.removeRosterAttendeeAction({ attendeeId: presentAttendeeId }));
          } else {
            const { Name, IsRecordingUser } = await attendee(externalUserId);
            dispatch(
              chimeActions.addRosterAttendeeAction({
                attendeeId: presentAttendeeId,
                value: {
                  name: Name,
                  isRecordingUser: IsRecordingUser,
                  externalUserId,
                  muted: true,
                },
              })
            );
            audioVideo.realtimeSubscribeToVolumeIndicator(
              presentAttendeeId,
              (attendeeId, volume, muted) => {
                if ((muted === true || muted === false) && attendeeId) {
                  dispatch(
                    chimeActions.updateRosterAttributeAction({
                      attendeeId,
                      key: 'muted',
                      value: muted,
                    })
                  );
                }
              }
            );
          }
        }
      );
      audioVideo.realtimeSubscribeToSetCanUnmuteLocalAudio((canUnmute) => {
        dispatch(audioVideoActions.realtimeSubscribeToSetCanUnmuteLocalAudioAction({ canUnmute }));
      });

      audioVideo.addDeviceChangeObserver({
        audioInputsChanged: (freshAudioInputDeviceList) => {
          dispatch(
            audioVideoActions.deviceChangedAction({
              deviceList: 'audioInputDevices',
              deviceType: 'currentAudioInputDevice',
              freshDeviceList: freshAudioInputDeviceList,
            })
          );
        },
        audioOutputsChanged: (freshAudioOutputDeviceList) => {
          dispatch(
            audioVideoActions.deviceChangedAction({
              deviceList: 'audioOutputDevices',
              deviceType: 'currentVideoInputDevice',
              freshDeviceList: freshAudioOutputDeviceList,
            })
          );
        },
        videoInputsChanged: (freshVideoInputDeviceList) => {
          dispatch(
            audioVideoActions.deviceChangedAction({
              deviceList: 'audioInputDevices',
              deviceType: 'currentAudioOutputDevice',
              freshDeviceList: freshVideoInputDeviceList,
            })
          );
        },
      });
    }
    return () => {
      // audioVideo.realtimeUnsubscribeToAttendeeIdPresence();
      // audioVideo.realtimeUnsubscribeToSetCanUnmuteLocalAudio();
      //Turn off listenser
    };
    //eslint-disable-next-line
  }, [hasJoined]);
  return children;
}
